import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetEmployeeSelector({
  value,
  displayValue,
  employees,
  onChange,
  viewOnly,
  reloadDropdownData,
  size,
  showCloudIcon = true
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
      selectedValue={value}
      displayValue={displayValue}
      options={employees}
      onChange={(values) => onChange(values)}
      reloadDropdownData={() => {
        if (typeof reloadDropdownData === 'function') {
          reloadDropdownData()
        }
      }}
      placeHolder="Select Employee"
      showCloudIcon={showCloudIcon}
      size={size}
    />
    </React.Fragment>
  )
}
